import State from 'store/State';
import { selectComponentKeysByType } from 'layout/store/selectors';
import { WidgetType } from 'widgets/WidgetType';
import { selectWidgetInstancesState } from 'widgets/store/selectors';

export const selectPortfolioReturnsWidgetKeys: (state: State) => string[] = (
    state
) => selectComponentKeysByType(state, WidgetType.PORTFOLIO_RETURNS);

export const selectPortfolioReturnsWidgetsState = (state: State) =>
    selectWidgetInstancesState(state).portfolioReturns;

export const selectPortfolioReturnsState = (state: State, widgetKey: string) =>
    selectPortfolioReturnsWidgetsState(state)[widgetKey];
